<script lang="ts">
	import { Icons } from '$lib/components/icon'
	import { generateSecurePassword } from '$lib/components/signUp/generatePassword'
	import { _ } from '@repo/i18n'
	import { InputType } from '@repo/ui'
	import { Action } from '@repo/ui'
	import { Input } from '@repo/ui'
	import { user } from '@repo/ui'
	import type { UsersV1RegisterUserRequest } from '@sdk/Api'

	interface Props {
		form: UsersV1RegisterUserRequest
		withUser?: boolean
		withPassword?: boolean
	}

	let { form = $bindable(), withUser = false, withPassword = true }: Props = $props()

	function generateRandomPassword() {
		form.password = generateSecurePassword()
	}
</script>

<Input
	name="name"
	hideRequired
	icon={Icons.User}
	label={$_('signUp.form.fullName')}
	max={50}
	min={2}
	placeholder={$_('form.fullNamePlaceholder')}
	required
	bind:value={form.name}
/>

{#if !$user || withUser}
	<Input
		name="email"
		autocomplete="off"
		hideRequired
		icon={Icons.Envelope}
		label={$_('form.email')}
		placeholder={$_('form.emailPlaceholder')}
		required
		type={InputType.email}
		bind:value={form.email}
	/>

	{#if withPassword}
		<Input
			name="password"
			autocomplete="off"
			hideRequired
			icon={Icons.LockClosed}
			label={$_('form.password')}
			min={6}
			placeholder={$_('form.passwordPlaceholder', { values: { min: 6 } })}
			required
			type={withUser ? InputType.text : InputType.password}
			bind:value={form.password}
		>
			{#snippet action()}
				{#if withUser}
					<Action
						name="generate-password"
						ariaLabel={$_('form.passwordGenerate')}
						icon={Icons.ArrowPath}
						onclick={generateRandomPassword}
						title={$_('form.passwordGenerate')}
					/>
				{/if}
			{/snippet}
		</Input>
	{/if}
{/if}
